<template>
  <div id="forgot-password">
    <b-container>
      <b-row>
        <b-col sm="7" class="d-none d-sm-block">
          &nbsp;
        </b-col>
        <b-col sm="12" md="5" id="right-content" class="d-flex align-items-center">
          <div id="form-wrapper">
            <h1>Reset Password</h1>
            <b-form id="login-form" @keydown.enter.prevent="forgot">
              <span id="invalidCreds" v-if="apiErrors.FORGOT_PASSWORD">
                We have no account associated with your email
              </span>

              <b-form-group class="inputField">
                <div class="input-wrapper">
                  <b-form-input
                    id="email"
                    name="email"
                    v-model="$v.credentials.email.$model"
                    :state="validateState('email')"
                  />
                  <label for="user">Email</label>
                  <b-form-invalid-feedback
                    v-if="!$v.credentials.email.required"
                    class="login-error"
                  >
                    Email is required
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback
                    id="inputLiveFeedback"
                    v-if="!$v.credentials.email.email"
                    class="login-error"
                  >
                    Insert a valid Email
                  </b-form-invalid-feedback>
                </div>
              </b-form-group>
              <div class="text-center">
                <button
                    @click.prevent="forgot"
                    :disabled="$v.credentials.$invalid"
                    id="login-button"
                  >
                  RESET MY PASSWORD
                </button>
              </div>
            </b-form>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, sameAs, email } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";

export default {
  mixins: [validationMixin],
  data() {
    return {
      credentials: {
        email: null,
      },
    };
  },
  validations: {
    credentials: {
      email: {
        required,
        email,
      },
    },
  },

  computed: {
    ...mapState(["apiErrors"]),
  },
  methods: {
    ...mapActions(["FORGOT_PASSWORD", "CLEAR_API_ERRORS", "CLEAR_RESET_MESSAGE_FLAG"]),

    validateState(name) {
      const { $dirty, $error } = this.$v.credentials[name];
      return $dirty ? !$error : null;
    },
    forgot(){
      this.FORGOT_PASSWORD(this.credentials).then((res) => {
        this.$router.push('/log-in');
      }).catch((err) => console.log('404'));
    }
  },
  watch: {
  },
  mounted() {
    this.CLEAR_API_ERRORS();
    this.CLEAR_RESET_MESSAGE_FLAG();
  },
};
</script>

<style lang="less" >
@import "../../assets/components/signIn/forgotPassword.less";
@import "../../assets/components/common/FormInput.less";
</style>